import module from 'module';
import _ from 'lodash';

import templateUrl from './compliance-list.template.html';
import './compliance-list.style.less';

class ComplianceListView {
  constructor(systemPropertyCache) {
    this.systemPropertyCache = systemPropertyCache;
  }

  async $onInit() {
    let systemProperties = await this.systemPropertyCache.toPromise();
    let canShowSystemAlerts = _.find(systemProperties, {code: 'SYSTEM_ALERTS_ENABLED'}).value === 'TRUE';

    this.options = [
      {name: 'Force profile update', url: '#!/admin/compliance/force-profile-update', visible: true},
      {name: 'Risk assessment', url: '#!/admin/compliance/risk/assessment', visible: true},
      {name: 'Risk profiling categories', url: '#!/admin/compliance/risk/categories', visible: true},
      {name: 'Watchlist', url: '#!/admin/compliance/watchlist', visible: true},
      {name: 'Red flag configuration', url: '#!/admin/compliance/red-flag-config', visible: canShowSystemAlerts},
      {name: 'Red flag acknowledgement', url: '#!/admin/compliance/red-flag-acknowledgement', visible: canShowSystemAlerts}
    ];
  }

  openUrl(option) {
    return option.url;
  }
}

module.component('complianceListView', {
  templateUrl,
  controller: ComplianceListView
});
